import { toNumber } from "shared/mappers/coerce";
import type {
  CurrentUserDto,
  CurrentUserSchoolDto,
  CurrentUserStudentDto,
} from "./auth.dto";
import type {
  CurrentUser,
  CurrentUserSchool,
  CurrentUserStudent,
} from "./auth.types";

export const currentUserFromDto = (data: CurrentUserDto): CurrentUser => {
  return {
    id: data.id,
    shortage: data.shortage ?? null,
    studentNumber: data.student_number ?? null,
    formattedName: data.formatted_name,
    firstName: data.first_name,
    middleName: data.middle_name,
    lastName: data.last_name,
    email: data.email,
    profileImage: data.profile_image ?? null,
    nps: data.nps,
    unseenNotificationsCount: toNumber(data.unseen_notifications_count),
    unreadUpdatesCount: toNumber(data.unread_updates_count),
    openAssignmentsCount: data.open_assignments_count,
    openActionplansCount: data.open_actionplans_count,
    openConversationsCount: data.open_conversations_count,
    pendingAssessmentsCount: data.pending_assessments_count,
    pendingActionplanReviewsCount: data.pending_actionplan_reviews_count,
    school: currentUserSchoolFromDto(data.school),
    student: data.student ? currentUserStudentFromDto(data.student) : null,
  };
};

export const currentUserToDto = (data: CurrentUser): CurrentUserDto => {
  return {
    id: data.id,
    shortage: data.shortage,
    student_number: data.studentNumber,
    formatted_name: data.formattedName,
    first_name: data.firstName,
    middle_name: data.middleName,
    last_name: data.lastName,
    email: data.email,
    profile_image: data.profileImage,
    nps: data.nps,
    unseen_notifications_count: data.unseenNotificationsCount,
    unread_updates_count: data.unreadUpdatesCount,
    open_assignments_count: data.openAssignmentsCount,
    open_actionplans_count: data.openActionplansCount,
    open_conversations_count: data.openConversationsCount,
    pending_assessments_count: data.pendingAssessmentsCount,
    pending_actionplan_reviews_count: data.pendingActionplanReviewsCount,
    school: currentUserSchoolToDto(data.school),
    student: data.student ? currentUserStudentToDto(data.student) : null,
  };
};

const currentUserSchoolFromDto = (
  schoolDto: CurrentUserSchoolDto,
): CurrentUserSchool => {
  return {
    id: schoolDto.id,
    name: schoolDto.name,
  };
};

const currentUserSchoolToDto = (
  school: CurrentUserSchool,
): CurrentUserSchool => {
  return {
    id: school.id,
    name: school.name,
  };
};

const currentUserStudentFromDto = (
  studentDto: CurrentUserStudentDto,
): CurrentUserStudent => {
  return {
    id: studentDto.id,
    educationLevel: studentDto.education_level,
    educationYear: studentDto.education_year,
    formattedEducationLevel: studentDto.formatted_education_level,
    mentorClass: studentDto.mentor_class,
    mentors: studentDto.mentors,
    lessonGroups: studentDto.lesson_groups,
  };
};

const currentUserStudentToDto = (
  student: CurrentUserStudent,
): CurrentUserStudentDto => {
  return {
    id: student.id,
    education_level: student.educationLevel,
    education_year: student.educationYear,
    formatted_education_level: student.formattedEducationLevel,
    mentor_class: student.mentorClass,
    mentors: student.mentors,
    lesson_groups: student.lessonGroups,
  };
};
